import filmmaker from "./images/aboutPage/filmmaker-picture.jpg";

const AboutPageContent = {
  filmakerImage: filmmaker,
  contentPara1: `Cheryl Mukherji (b. 1995, India) is a visual artist and writer
    currently based in Brooklyn, New York. She graduated with an MFA in
    Advanced Photographic Studies from the International Center of
    Photography-Bard College, New York in 2020. In her current work,
    Cheryl explores the idea of origin and inheritance, which is embedded
    in the figure of her mother and her presence in the family album,
    using photography, text, and video.`,
  contentPara2: `Cheryl is a finalist for the Outwin Boochever Portrait Competition
    2022 at the National Portrait Gallery, Smithsonian, and a current
    Workspace Resident at Baxter Street at CCNY, New York where she will
    also host her debut solo show in January 2022. Previously, Cheryl has
    been the recipient of Capture Photography Festival’s Writing Prize
    2020, Brooklyn Museum’s #Your2020Portrait Award, South Asian Arts
    Resiliency Fund (SAARF), Firecracker Photography Grant 2020, and was a
    finalist for the Dorthea Lange-Paul Taylor Prize 2020. Her work has
    been exhibited at the Minnesota Museum of American Art (US),
    Huxley-Parlour Gallery (UK), Format Photo Festival (UK), Brooklyn
    Museum (US), Museum of Moving Image (US), International Center of
    Photography (US), Serendipity Arts Festival (IN), among others.`,
  emailId: "trueimkaveri.sharma@gmail.com",
  resumeDownloadLink: "../assests/images/aboutPage/filmmaker-picture.jpg",
};

export default AboutPageContent;
